export default __webpack_public_path__ + "static/media/private-eye.40263ad9.svg";